import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { DayPicker } from './DayPicker'

interface Props {
  canBeMarkedAsActive: boolean
  error?: boolean
  startDate: string | undefined
  endDate?: string | undefined | null
  handleSelectedDatesChange: (newDates: { startDate?: string; endDate?: string }) => void
}

export const DateSelectors = ({
  canBeMarkedAsActive,
  error,
  startDate,
  endDate,
  handleSelectedDatesChange,
}: Props) => {
  const hasError = !!error

  const errorMessage = hasError
    ? i18n.t('finance.cost_centers.assignments.day_picker.error_overlap')
    : undefined

  const handleStartDateChange = (date: string | undefined) => {
    handleSelectedDatesChange({ startDate: date })
  }

  const handleEndDateChange = (date: string | undefined) => {
    handleSelectedDatesChange({ endDate: date })
  }

  return (
    <Box>
      <Box flexDirection="row" gap="s24">
        <DayPicker
          selectedDate={startDate}
          handleSelectedDatesChange={handleStartDateChange}
          error={hasError}
          label={i18n.t('finance.cost_centers.assignments.day_picker.start_date')}
          maxDate={endDate || undefined}
          mandatory
        />

        <DayPicker
          minDate={startDate}
          selectedDate={endDate || undefined}
          handleSelectedDatesChange={handleEndDateChange}
          error={hasError}
          label={i18n.t('finance.cost_centers.assignments.day_picker.end_date')}
          mandatory={!canBeMarkedAsActive}
        />
      </Box>
      {hasError && (
        <Text.Normal size="200" color="radicalRed1000">
          {errorMessage}
        </Text.Normal>
      )}
    </Box>
  )
}
